import React, { useState, useEffect } from 'react'
import { CircularProgress, Typography, Button } from '@material-ui/core'
import { useArquivoService } from 'hooks/useArquivoService'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants' //eslint-disable-line
import { CloudDownload } from '@material-ui/icons'
import useStyles from './styles'

export const ExibirArquivo = (props) => {
  const classes = useStyles()
  const arquivoService = useArquivoService()
  const authService = useAuth() //eslint-disable-line

  const { id, rotaLoadFile, arquivo: arquivoProp } = props
  const [processando, setProcessando] = useState(false)
  const [arquivo, setArquivo] = useState(null)
  const [mimetype, setMimetype] = useState(arquivoProp?.mimetype || null)
  const [nomeOriginal, setNomeOriginal] = useState(arquivoProp?.nomeOriginal || null)

  const isImageType = (mime) => ['image/png', 'image/jpg', 'image/jpeg'].includes(mime)

  useEffect(() => {
    if (arquivoProp?.mimetype && arquivoProp?.nomeOriginal && !isImageType(arquivoProp.mimetype)) {
      setMimetype(arquivoProp.mimetype)
      setNomeOriginal(arquivoProp.nomeOriginal)
      setArquivo({ data: null })
      return
    }

    const fetchArquivo = async () => {
      const arq = await arquivoService.listarArquivo(rotaLoadFile, id, setProcessando)
      if (arq) {
        setArquivo(arq.arquivo)
        setNomeOriginal(arq.nomeOriginal)
        setMimetype(arq.mimetype)
      }
    }

    fetchArquivo()
  }, [id, rotaLoadFile, arquivoProp?.mimetype, arquivoProp?.nomeOriginal])

  const arrayBufferToBase64 = (buffer) => {
    if (!buffer) return ''
    const bytes = new Uint8Array(buffer)
    const chunkSize = 8192
    let binary = ''
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunkSize))
    }
    return window.btoa(binary)
  }

  const getRawImageContent = (data) => {
    const b64 = arrayBufferToBase64(data)
    const foto = `data:image/jpeg;base64,${b64}`
    return foto
  }

  const handleDownload = () => {
    arquivoService.downloadArquivo(rotaLoadFile, id, nomeOriginal)
  }

  const getSrc = (data, mimetype) => {
    switch (mimetype) {
      case 'image/png': {
        return getRawImageContent(data)
      }
      case 'image/jpg': {
        return getRawImageContent(data)
      }
      case 'image/jpeg': {
        return getRawImageContent(data)
      }
      case 'application/pdf': {
        return '/images/pdf_image.png'
      }
      default:
        return '/images/pdf_image.png'
    }
  }

  return (
    <div>
      {processando || !arquivo ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div className={classes.content}>
          {!isImageType(mimetype) ? (
            <img src={getSrc(arquivo?.data, mimetype)} width="50%" spacing={2} alt="" />
          ) : (
            <img src={getSrc(arquivo?.data, mimetype)} width="100%" spacing={2} alt="" />
          )}

          <Typography>{nomeOriginal}</Typography>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            className={classes.margin}
            onClick={() => handleDownload()}
            endIcon={<CloudDownload />}
          >
            Download
          </Button>
        </div>
      )}
    </div>
  )
}
